// Source/Instant-Search/Vendors/Cache.ts
var Marker_Product_Vendor = "\uD83C\uDFED";
var Hub_Path = `/search`;
var Endpoint_Product_Details = `${Hub_Path}?q=${Marker_Product_Vendor}`;
var Batch_Size = 6;
var vendors = new Map;
function getVendor(handle) {
  return vendors.get(handle);
}
async function cacheVendors(handles) {
  handles = handles.filter((handle) => !vendors.has(handle));
  const promises = new Array;
  while (handles.length) {
    const batch = handles.splice(0, Batch_Size);
    const promise = fetchBatch(batch).then((values) => {
      values.forEach((vendor) => {
        vendors.set(vendor.handle, vendor);
      });
      return values;
    });
    handles.forEach((handle) => {
      const value = promise.then((values) => {
        return values.find((value) => value.handle === handle);
      });
      vendors.set(handle, value);
    });
    promises.push(promise);
  }
  await Promise.allSettled(promises);
}
async function fetchBatch(handles) {
  const combined = handles.join(",");
  const payload = encodeURIComponent(combined);
  const query = `${Endpoint_Product_Details}${payload}`;
  const url = new URL(query, location.href);
  return await fetch(url).then((response) => response.json()).then((json) => json);
}

// Source/Instant-Search/Vendors/Misc.ts
function unique(iterable) {
  const array = Array.from(iterable);
  const set = new Set(array);
  const values = set.values();
  return Array.from(values);
}
function handleize(name) {
  return name.toLowerCase().replaceAll(/[\'\"\(\)\[\]]/g, "").replaceAll(/\W/g, (char) => /\p{L}/u.test(char) ? char : "-").replaceAll(/-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
}

// Source/Instant-Search/Vendors/Config.ts
var Selector = `#Instant-Search-Localizations`;
function loadConfig() {
  const script = document.querySelector(Selector);
  const json = script.textContent;
  return JSON.parse(json);
}

// Source/Instant-Search/Vendors/mod.ts
var Element = {
  Group_Last: `.boost-sd__suggestion-queries-group:last-child,.boost-sd__suggestion-queries-group:has( + .boost-sd__instant-search-product-list ),.boost-sd__suggestion-queries-group:has(+ .boost-sd__support-button-wrapper)`,
  Sidebar: `:has( > .boost-sd__suggestion-queries-group )`,
  Vendor: `.Result-Card-Vendor`
};
async function updateVendors(widget) {
  const config = loadConfig();
  const vendors = widget.querySelectorAll(Element.Vendor);
  if (vendors.length === 0)
    return;
  const sidebar = widget.querySelector(Element.Sidebar);
  const parent = document.createElement("div");
  parent.classList.add("boost-sd__suggestion-queries-group");
  const title = document.createElement("h3");
  title.innerText = config.Title;
  title.tabIndex = 0;
  title.role = "text";
  title.classList.add("boost-sd__suggestion-queries-header--vendors", "boost-sd__suggestion-queries-header", "boost-sd__header-item");
  parent.appendChild(title);
  const list = document.createElement("ul");
  list.classList.add("boost-sd__suggestion-queries-list");
  parent.appendChild(list);
  let names = Array.from(vendors).map((element) => element.textContent.trim());
  names = unique(names);
  const handles = names.map(handleize);
  await cacheVendors(handles);
  const promises = names.map(async (name) => {
    try {
      const handle = handleize(name);
      const vendor = await getVendor(handle);
      if (!vendor)
        return false;
      const selector = `
                .boost-sd__suggestion-queries-group:has(
                    .boost-sd__suggestion-queries-header--collections
                )
                .boost-sd__suggestion-queries-link[
                    href = '${vendor.link}'
                ]
            `;
      const related = widget.querySelector(selector);
      related?.parentElement?.remove();
      const element = document.createElement("li");
      element.dataset.extraParam = String(false);
      element.dataset.title = name;
      element.classList.add("boost-sd__suggestion-queries-item--mobile-style1", "boost-sd__suggestion-queries-item");
      list.appendChild(element);
      const link = document.createElement("a");
      link.ariaLabel = `Vendor : ${name}`;
      link.href = vendor.link;
      link.classList.add("boost-sd__suggestion-queries-link");
      element.appendChild(link);
      const content = document.createElement("span");
      content.ariaHidden = String(true);
      content.innerText = name;
      link.appendChild(content);
    } catch (exception) {
      console.error(exception);
    }
    return true;
  });
  const outcome = await Promise.allSettled(promises);
  const success = outcome.filter((promise) => promise.status === "fulfilled").find((promise) => promise.value === true);
  if (success) {
    const last = sidebar.querySelector(Element.Group_Last);
    last.after(parent);
  }
}

// Source/Instant-Search/Fetch.ts
var Action_Marker = "\uD83D\uDD0D";
var Search_Path = `/search`;
var Endpoint = `${Search_Path}?q=${Action_Marker}`;
async function fetchHTML(results) {
  const combined = results.map((result) => result.join(",")).join(";");
  const payload = encodeURIComponent(combined);
  const query = `${Endpoint}${payload}`;
  const url = new URL(query, location.href);
  return await fetch(url).then((response) => response.text()).then((text) => {
    if (text.includes("❌"))
      return null;
    return text;
  });
}

// Source/Instant-Search/Results.ts
var Wrapper_Selector = `.boost-sd__search-widget-init-wrapper,.boost-sd__search-bar-wrapper--mobile`;

class SearchResults extends HTMLElement {
  async connectedCallback() {
    const { data } = this;
    const html = await fetchHTML(data);
    if (html)
      this.insertAdjacentHTML("afterend", html);
    const { widget } = this;
    this.remove();
    updateVendors(widget);
  }
  get widget() {
    return this.closest(Wrapper_Selector).parentElement;
  }
  get data() {
    const script = this.querySelector("script");
    const json = script.textContent;
    return JSON.parse(json);
  }
}

// Source/Instant-Search/mod.ts
customElements.define("search-results", SearchResults);
